import { render, staticRenderFns } from "./ReportFormDescription.vue?vue&type=template&id=a5495ad4&"
import script from "./ReportFormDescription.vue?vue&type=script&lang=ts&"
export * from "./ReportFormDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports